// export const text = [
//   {
//     // 冠名
//     sponsor: '太原理工大学',
//     //数据介绍
//     introduce: {
//       name: '星系马戏团--二十八星宿赛季', text: '二十八星宿，作为中国古代天文学家计量太阳、月亮、五大行星、彗星等运动天体的运行位置的重要依据，是中国古代天文学赤道坐标系的重要组成部分，在中国古代的星历和农历中起到了时间计量和导航的作用。中国传统的赤道坐标系将赤道分为365.25度，太阳运行一天转一度，也是28宿的宿度数之和。古人在春分日的傍晚仰观天象，按照东南西北四个方位，将28宿划分成了四段，每段对应一象，各包含七宿：鸟象在南，龙象、虎象分别在东、西方，龟蛇则隐没于北方地平线下。春秋战国时期，流行五行配五色之说，分别将青、赤、黄、白、黑与东方、南方、中央、西方、北方相配，最后就形成了东方苍(青)龙、西方白虎、南方朱雀(鸟)、北方玄武(龟蛇)的说法。',

//       text1: '二十八星宿赛季的异常星系标注活动不仅是对太空探索的一次全新尝试，也是对人类智慧和勇气的考验。我们诚邀您参与异常星系查找项目，共同探索宇宙的奥秘。无论您是否具备天文学背景，只需一颗对宇宙的好奇心和一台计算机，您就可以成为我们的伙伴。通过与科学家的合作，您将有机会发现并研究那些独特的异常扩展天体，为天文学的发展做出贡献。让我们携手揭开宇宙的神秘面纱。', src: require('@/assets/zongshu.jpg')
//     },
//     dataintroduce: {
//       name: '青龙赛季', text: '东方青龙分别对应于角、亢、氐、房、心、尾、箕。角代表了龙的角。亢代表了龙的喉咙，“吭”的通假字，代表着喉咙。氐代表了骶，尾椎骨。房代表了腹部，胸房。心就是龙心，尾是龙尾，箕代表了簸箕，长得像簸箕。古时将天上星空区域与地上的国、州互相对应，即为分野。二十八星宿也是分野的一种依据，如东方苍龙，是指古代分布于中国东部的以龙为图腾的东夷民族。东夷分布极广，先秦的郑、宋、燕，直到东北和朝鲜，都有他们的分布。故郑为龙首、宋为龙身、燕为龙尾。',

//       text1: '数据介绍：暗能量光谱仪器(DESI)计划是一项由美国能源部和自然基金会支持的大型国际合作光谱巡天项目，旨在进行第四代宇宙学星系红移巡天，延续了斯隆数字巡天(SDSS)的研究成果。该计划计划历时5年，通过获取约4000万天体的光谱数据，构建迄今为止最大的三维宇宙模型，以研究暗能量对宇宙膨胀的影响。目前，我们的星系马戏团(Galaxy circus)--人工智能辅助的异常扩展天体发现项目使用的图像数据就来自于DESI图像巡天的第9版数据DR9。本赛季使用数据赤经范围为13h25m11.6s-18h45m39.4s。',

//       text2: '赛季规则：赛季周期三个月，每个赛季初积分清零，每一次比赛的排名情况都将在28星宿赛季结束后进行公布。',

//       text3: '得分小技巧：每进行一次有效“探寻”、发现一个有效异常天体并成功提交后，将获得一定数量的积分奖励(标记结果可在个人中心查看)。同时，用户连续登录参与活动，标注数目大于一定数目、准确率高都会的到积分加成。积分可以累积，在达到一定数量时可以获得荣誉称号、兑换实物奖品。',

//       text4: '注意事项：',

//       text5: '1. 标注准确率下降会导致分数的下降！要保证标注的准确率！',

//       text6: '2. 每个赛季的开始将根据您的上赛季的表现进行初始积分奖励！', src: require('@/assets/qinglong.jpg'),
//       text7: '角，位于“龙角”，赤经为13h25m11.6s。日月五星都穿过角宿，古人认为黄道经角中经过，为天之关口，所古人把角宿作为28宿的第一宿。角宿总共两星，属于室女座。两星像龙角，因而得名角宿。',
//       text8: '亢，位于“龙的咽喉”，赤经为14h12m53.8s。在实际天象中，“亢宿一”经过它的边界线，另外一条边界线经过“氐宿一”。亢宿有四颗星，属于室女座,但较角宿小，其中的星也较暗弱，多为四等以下。四星像高抬的龙颈，而“亢”本身就有“高”的意思，故而得名。',
//       text9: '氐，位于“龙的前足”，赤经为14h50m52.8s。处在现代星座划分的天秤座，含有4颗恒星。《尔雅 释天》：“天根，氐也。”因此氐可理解为龙的前足。',
//       text10: '房是腹部，胸房，赤经为15h58m51.1s。位于现代星座划分的天蝎座，含有4颗星。《史记天官书》：“房为府，天驷也。”。《尔雅 释天》：“天驷，房也”。',
//       text11: '心是龙心，赤经为16h21m11.3s。位于现代星座划分的天蝎座，含有3颗恒星，其中最亮星为心宿二，又称大火星，为全天第十四亮星。心星，即著名的心宿二（天蝎alpha），古代称之为火，大火，或商星。',
//       text12: '尾即龙尾，赤经为16h51m52.2s。含9星，意为“苍龙的尾”，位于现代星座划分的天蝎座。其中，最亮星为尾宿八，星等达1.62等。《左传》：“童谣云‘丙之晨，龙尾伏辰’”，注称：“龙尾者，尾星也。日月之会曰辰，日在尾，故尾星伏不见”。',
//       text13: '箕，其形像簸箕，赤经为18h05m48.5s。位于现代星座划分的人马座，含有4颗恒星。《诗小雅》：“维南有箕，不可以簸扬。”指的便是箕。',
//     },
//   },
//   {
//     // 冠名
//     sponsor: '太原理工大学',
//     //数据介绍
//     introduce: {
//       name: '星系马戏团--二十八星宿赛季', text: '二十八星宿，作为中国古代天文学家计量太阳、月亮、五大行星、彗星等运动天体的运行位置的重要依据，是中国古代天文学赤道坐标系的重要组成部分，在中国古代的星历和农历中起到了时间计量和导航的作用。中国传统的赤道坐标系将赤道分为365.25度，太阳运行一天转一度，也是28宿的宿度数之和。古人在春分日的傍晚仰观天象，按照东南西北四个方位，将28宿划分成了四段，每段对应一象，各包含七宿：鸟象在南，龙象、虎象分别在东、西方，龟蛇则隐没于北方地平线下。春秋战国时期，流行五行配五色之说，分别将青、赤、黄、白、黑与东方、南方、中央、西方、北方相配，最后就形成了东方苍(青)龙、西方白虎、南方朱雀(鸟)、北方玄武(龟蛇)的说法。',

//       text1: '二十八星宿赛季的异常星系标注活动不仅是对太空探索的一次全新尝试，也是对人类智慧和勇气的考验。我们诚邀您参与异常星系查找项目，共同探索宇宙的奥秘。无论您是否具备天文学背景，只需一颗对宇宙的好奇心和一台计算机，您就可以成为我们的伙伴。通过与科学家的合作，您将有机会发现并研究那些独特的异常扩展天体，为天文学的发展做出贡献。让我们携手揭开宇宙的神秘面纱。', src: require('@/assets/zongshu.jpg')
//     },
//     dataintroduce: {
//       name: '玄武赛季', text: '北方玄武包括斗、牛、女、虚、危、室、壁。北方七宿共六十五个星座，八百余颗星，它们组成了蛇与龟的形象，故称为玄武。斗宿为北方玄武元龟之首，由六颗星组成，状亦如斗，一般称其为南斗，它与北斗一起掌管着生死大权，又称为天庙。牛宿指“牵牛的人”，女宿为“婺女”，虚宿主星即尧典四星之一的虚星。危，屋栋之上的意思，也有说法来自于三危山。室、壁，营室，东壁的意思，可能含有加固院墙之意。',

//       text1: '数据介绍：暗能量光谱仪器(DESI)计划是一项由美国能源部和自然基金会支持的大型国际合作光谱巡天项目，旨在进行第四代宇宙学星系红移巡天，延续了斯隆数字巡天(SDSS)的研究成果。该计划计划历时5年，通过获取约4000万天体的光谱数据，构建迄今为止最大的三维宇宙模型，以研究暗能量对宇宙膨胀的影响。目前，我们的星系马戏团(Galaxy circus)--人工智能辅助的异常扩展天体发现项目使用的图像数据就来自于DESI图像巡天的第9版数据DR9。本赛季使用数据赤经范围为18h45m39.4s-00h57m12.3s。',

//       text2: '赛季规则：赛季周期三个月，每个赛季初积分清零，每一次比赛的排名情况都将在28星宿赛季结束后进行公布。',

//       text3: '得分小技巧：每进行一次有效“探寻”、发现一个有效异常天体并成功提交后，将获得一定数量的积分奖励(标记结果可在个人中心查看)。同时，用户连续登录参与活动，标注数目大于一定数目、准确率高都会的到积分加成。积分可以累积，在达到一定数量时可以获得荣誉称号、兑换实物奖品。',

//       text4: '注意事项：',

//       text5: '1. 标注准确率下降会导致分数的下降！要保证标注的准确率！',

//       text6: '2. 每个赛季的开始将根据您的上赛季的表现进行初始积分奖励！', src: require('@/assets/xuanwu.jpg'),
//       text7: '斗，也称南斗，赤经为18h45m39.4s。斗宿含六颗星，即南斗六星，清钦天监所编《仪象考成》及《仪象考成续编》，斗增加了五颗星。与北斗七星一样，南斗六星在天空中的形状也很像斗，故名，但南斗的范围和亮度较之北斗则有所不及了。',
//       text8: '牛，本指今河鼓三星，即牵牛星，赤经为20h21m0.7s。含有6颗恒星，视星等均在3等以下。',
//       text9: '女，古称婺女或须女，赤经为。女宿含四颗恒星，视星等均暗于3。清钦天监所编《仪象考成》及《仪象考成续编》，女增加了5颗恒星。《礼记月令》中云：“孟夏之月……旦婺女中。”就是指如果黎明时看到女宿在南方中天的位置，便晓得初夏来临了。',
//       text10: '虚，赤经为20h47m40.6s。虚宿在远古时即已相当著名，成书于周代的《尚书尧典》中记载的四仲中星里就有虚宿，“宵中星虚，以殷仲秋。”彼时虚宿在秋分前后的傍晚出现 在南方中天。从牛宿二向女宿一作假想的连线，并延长约一倍半，所碰到的一颗三等星便是虚宿一。',
//       text11: '危，像高高的屋顶，“危”即“高”，赤经为22h05m47.0s。《史记索隐》中引《礼记》称：“中屋履危，盖升屋以避兵也。”《史记天官书》：“危为盖屋。”《晋书天文志》：“危三星，主天府市架屋。”三星的形状就有如一个尖屋顶。',
//       text12: '室和壁是相连的两宿，古有营室，东壁之，赤经为23h04m45.7s，00h13m14.2s。营室原为四星，成四方形，有东壁，西壁各两星，正如宫室之象。《周官梓人》：“龟蛇四游，以象营室也。”其后东壁从营室中分出，成为了室，壁两宿。',
//       text13: '曾侯乙墓漆箱盖上称这两宿为西萦与东萦。东壁，西壁四星，就是著名的飞马座四边形。《诗风》：“定之方中，作于楚宫。”春秋时期室宿在秋末冬初的傍晚出现 在南方中天，此时是农闲时节，人们利用这段时间建造房屋为冬天作准备，因此有营室之称，从壁宿二向壁宿一连线并约延长一倍，就可找到春分点的大概位置。',
//     },
//   },
//   {
//     // 冠名
//     sponsor: '太原理工大学',
//     //数据介绍
//     introduce: {
//       name: '星系马戏团--二十八星宿赛季', text: '二十八星宿，作为中国古代天文学家计量太阳、月亮、五大行星、彗星等运动天体的运行位置的重要依据，是中国古代天文学赤道坐标系的重要组成部分，在中国古代的星历和农历中起到了时间计量和导航的作用。中国传统的赤道坐标系将赤道分为365.25度，太阳运行一天转一度，也是28宿的宿度数之和。古人在春分日的傍晚仰观天象，按照东南西北四个方位，将28宿划分成了四段，每段对应一象，各包含七宿：鸟象在南，龙象、虎象分别在东、西方，龟蛇则隐没于北方地平线下。春秋战国时期，流行五行配五色之说，分别将青、赤、黄、白、黑与东方、南方、中央、西方、北方相配，最后就形成了东方苍(青)龙、西方白虎、南方朱雀(鸟)、北方玄武(龟蛇)的说法。',

//       text1: '二十八星宿赛季的异常星系标注活动不仅是对太空探索的一次全新尝试，也是对人类智慧和勇气的考验。我们诚邀您参与异常星系查找项目，共同探索宇宙的奥秘。无论您是否具备天文学背景，只需一颗对宇宙的好奇心和一台计算机，您就可以成为我们的伙伴。通过与科学家的合作，您将有机会发现并研究那些独特的异常扩展天体，为天文学的发展做出贡献。让我们携手揭开宇宙的神秘面纱。', src: require('@/assets/zongshu.jpg')
//     },
//     dataintroduce: {
//       name: '白虎赛季', text: '西方白虎，包含奎，娄，胃，昴，毕，参，觜。古代将网小而柄长者称为毕，毕星又号称雨师(箕星为风伯)，又名屏翳、号屏、玄冥(与室宿相同)；我国以毕宿为雨星。觜宿三星几乎完全靠在一起。参宿七星，七颗星均很亮，在天空中非常显眼。参宿的中间三星与心宿的大火星（即商星），二者此出彼没，不同时在天空中出现，同一地方的人们不能在同一时间看到它们，因此民间有“参商不相见”的说法。',

//       text1: '数据介绍：暗能量光谱仪器(DESI)计划是一项由美国能源部和自然基金会支持的大型国际合作光谱巡天项目，旨在进行第四代宇宙学星系红移巡天，延续了斯隆数字巡天(SDSS)的研究成果。该计划计划历时5年，通过获取约4000万天体的光谱数据，构建迄今为止最大的三维宇宙模型，以研究暗能量对宇宙膨胀的影响。目前，我们的星系马戏团(Galaxy circus)--人工智能辅助的异常扩展天体发现项目使用的图像数据就来自于DESI图像巡天的第9版数据DR9。本赛季使用数据赤经范围为00h57m12.3s-6h22m57.6s。',

//       text2: '赛季规则：赛季周期三个月，每个赛季初积分清零，每一次比赛的排名情况都将在28星宿赛季结束后进行公布。',

//       text3: '得分小技巧：每进行一次有效“探寻”、发现一个有效异常天体并成功提交后，将获得一定数量的积分奖励(标记结果可在个人中心查看)。同时，用户连续登录参与活动，标注数目大于一定数目、准确率高都会的到积分加成。积分可以累积，在达到一定数量时可以获得荣誉称号、兑换实物奖品。',

//       text4: '注意事项：',

//       text5: '1. 标注准确率下降会导致分数的下降！要保证标注的准确率！',

//       text6: '2. 每个赛季的开始将根据您的上赛季的表现进行初始积分奖励！', src: require('@/assets/baihu.jpg'),
//       text7: '奎，意为（白虎的）足”，赤经为00h57m12.3s。奎宿十六星，左右两半正如两髀的形状，清代时又增补了23颗增星，位于现代星座划分的仙女座和双鱼座。《步天歌》中把奎宿描述成：“腰细头尖似破鞋，一十六星绕鞋生”。',
//       text8: '娄，通搂，象征大司马，“娄”指招揽聚众，赤经为01h54m38.4s。含有3颗星，位于现代星座划分的白羊座；后补有15颗增星，位于白羊座、双鱼座和三角座。古代的天文典籍中把娄宿视为主管牧养牺牲或兴兵聚众的地方。',
//       text9: '胃，意为“胃”或“谷仓”，赤经为02h43m27.1s。《释名》：“胃，围也，围受食物也”。《史记 天官书》：“胃为天仓”。位于现代星座划分的白羊座，含有3颗恒星。',
//       text10: '昴，像矛和矛头上的缨髦，赤经为03h44m52.5s。含有恒星7颗，即昴星团。在清代的星表《仪象考成》及《仪象考成续编》，昴新增13星。古人用昴宿来定四时，《尚书尧典》：“日短星昴，以正仲冬”，是指如果日落时看到昴宿在中天，就可以知道冬至到了。',
//       text11: '毕，赤经为04h28m37.0s。含有8颗恒星，后又增补18颗。《史记天官书》上说：“昴毕间为天街”，是指日月行星常经过这里，水星正位于这两个星宿之间。《诗经》称：“月离于毕，俾滂沱矣”。是指月亮经过毕宿时雨季来临。',
//       text12: '觜，像嘴，“觜”通“嘴”，赤经为5h35m8.3s。含有三颗星。《说文》：“鸱奋头上角觜也“，注称：“凡羽族之咮锐，故鸟咮曰觜。”觜宿三小星位于参宿两肩上方，形状可与角状的鸟嘴相联系，故名。',
//       text13: '参，赤经为05h40m45.5s。《西步天歌》：“参宿七星明烛宵，两肩两足三为腰”。参宿在夜空中的夺目程度由此可见一斑。从冬季到次年的初夏，参宿都是夜空中最醒目的一个星座。参宿一和心宿二的赤经相差约180度，同一地方的人们不能在同一时间看到它们，因此民间有“参商不相见”的说法。',
//     },
//   },
//   {
//     // 冠名
//     sponsor: '太原理工大学',
//     //数据介绍
//     introduce: {
//       name: '星系马戏团--二十八星宿赛季', text: '二十八星宿，作为中国古代天文学家计量太阳、月亮、五大行星、彗星等运动天体的运行位置的重要依据，是中国古代天文学赤道坐标系的重要组成部分，在中国古代的星历和农历中起到了时间计量和导航的作用。中国传统的赤道坐标系将赤道分为365.25度，太阳运行一天转一度，也是28宿的宿度数之和。古人在春分日的傍晚仰观天象，按照东南西北四个方位，将28宿划分成了四段，每段对应一象，各包含七宿：鸟象在南，龙象、虎象分别在东、西方，龟蛇则隐没于北方地平线下。春秋战国时期，流行五行配五色之说，分别将青、赤、黄、白、黑与东方、南方、中央、西方、北方相配，最后就形成了东方苍(青)龙、西方白虎、南方朱雀(鸟)、北方玄武(龟蛇)的说法。',

//       text1: '二十八星宿赛季的异常星系标注活动不仅是对太空探索的一次全新尝试，也是对人类智慧和勇气的考验。我们诚邀您参与异常星系查找项目，共同探索宇宙的奥秘。无论您是否具备天文学背景，只需一颗对宇宙的好奇心和一台计算机，您就可以成为我们的伙伴。通过与科学家的合作，您将有机会发现并研究那些独特的异常扩展天体，为天文学的发展做出贡献。让我们携手揭开宇宙的神秘面纱。', src: require('@/assets/zongshu.jpg')
//     },
//     dataintroduce: {
//       name: '朱雀赛季', text: '南方朱雀，井、鬼、柳、星、张、翼、轸计有四十二个星座，五百多颗星，它的形象是一只展翅飞翔的朱雀。井宿八星如井，大致相当于现代星座划分中双子座的脚部，附近有北河、南河(即小犬星座)、积水、水府等星座。鬼宿四星，据说一管积聚马匹、一管积聚兵士、一管积聚布帛、一管积聚金玉，附近还有天狗、天社、外厨等星官。柳宿八星，状如垂柳，它是朱雀的口。星宿七星，是朱雀的颈，附近是轩辕十七星。张宿六星为朱雀的嗉子，附近有天庙十四星。翼宿二十二星，算是朱雀的翅膀和尾巴。轸宿四星又名天车，四星居中，旁有左辖、右辖两星，"车之象也"。南方七宿基本上围绕着朱雀鸟来命名的，鸟嘴、鸟颈脖、鸟羽翼、鸟尾巴，一应俱全。',

//       text1: '数据介绍：暗能量光谱仪器(DESI)计划是一项由美国能源部和自然基金会支持的大型国际合作光谱巡天项目，旨在进行第四代宇宙学星系红移巡天，延续了斯隆数字巡天(SDSS)的研究成果。该计划计划历时5年，通过获取约4000万天体的光谱数据,构建迄今为止最大的三维宇宙模型，以研究暗能量对宇宙膨胀的影响。目前，我们的星系马戏团(Galaxy circus)--人工智能辅助的异常扩展天体发现项目使用的图像数据就来自于DESI图像巡天的第9版数据DR9。本赛季使用数据赤经范围为6h22m57.6s-13h25m11.6s。',

//       text2: '赛季规则：赛季周期三个月，每个赛季初积分清零，每一次比赛的排名情况都将在28星宿赛季结束后进行公布。',

//       text3: '得分小技巧：每进行一次有效“探寻”、发现一个有效异常天体并成功提交后，将获得一定数量的积分奖励(标记结果可在个人中心查看)。同时，用户连续登录参与活动，标注数目大于一定数目、准确率高都会的到积分加成。积分可以累积，在达到一定数量时可以获得荣誉称号、兑换实物奖品。',

//       text4: '注意事项：',

//       text5: '1. 标注准确率下降会导致分数的下降！要保证标注的准确率！',

//       text6: '2. 每个赛季的开始将根据您的上赛季的表现进行初始积分奖励！', src: require('@/assets/zhuque.jpg'),
//       text7: '井，赤经为6h22m57.6s，含有8颗星，其中最亮星为井宿三，视星等为1.93。《史记天官书》：“东井为水事”，井宿八星的形状有如一个水井，故名。井宿属于双子座，井宿就位于北河和参宿之间，这是寻找井宿的一个方法。',
//       text8: '鬼，又称舆鬼，赤经为8h31m35.7s。鬼宿被认为主丧祠之事。《观象玩占》：“鬼中央白色如粉絮者，谓之积尸气。一曰天尸，主死丧祠。”',
//       text9: '柳，原名为咮，咮是鸟嘴的意思，这与角为龙角的意义相似，赤经为8h37m39.4s。《尔雅 释天》：“咮谓之柳，柳，鹑火也”。柳宿八星，形状弯曲，像鸟嘴，也像垂柳，《步天歌》：“柳八星，曲头重如柳”。',
//       text10: '星，原名“七星”，由七颗星组成，赤经为09h27m35.2s。《史记索隐》：“颈，朱鸟颈也。员官，喉也。物在喉咙，终不久留，故主急事。”星宿位于长蛇的心脏。《步天歌》：“七星如钩柳下生，星上十七轩辕形”，指出了星宿的相对位置。',
//       text11: '张，赤经为09h51m28.7s。《尔雅》：“鸟张嗉”，注称：“嗉，鸟受食之处也。”可见张宿取意于朱鸟。张宿六星，其形状像张开的弓矢。',
//       text12: '翼，赤经为10h59m45.9s。也取意于朱鸟，《史记 天官书》：“翼为羽翮”。翼宿二十二星，形状就如张开的鸟翼。',
//       text13: '轸，赤经为12h15m48.4s。在曾侯乙墓的漆箱盖上写作车，《史记天官书》：“轸为车”，《索隐》：“轸四星居中，又有二星为左右辖，车之象也。”《说文》：“轸，车后横木也”，辖是指车轴上插着的小铁棍，可以使轮子不脱落。轸宿四星和左右辖均属于乌鸦座，《西步天歌》：“轸宿四珠不等方，长沙一黑中间藏”。',
//     },
//   },
// ]

// // 数组索引
// let monthIdx = new Date().getMonth();
// if (monthIdx == 2 || monthIdx == 3 || monthIdx == 4) {
//   monthIdx = 0
// } else if (monthIdx == 5 || monthIdx == 6 || monthIdx == 7) {
//   monthIdx = 1
// } else if (monthIdx == 8 || monthIdx == 9 || monthIdx == 10) {
//   monthIdx = 2
// } else {
//   monthIdx = 3
// }
// export const index = monthIdx;


export const text = [
  {
    // 冠名
    sponsor: '太原理工大学',
    //数据介绍
    introduce: {
      name: '星系马戏团--异常星系协同标注项目', text: '异常星系协同标注赛季不仅标志着公众科学在深空探索中的重要拓展，更是对人类认知边界与协作智慧的一次深度挑战。本季度活动由天文学专家团队主导，围绕前沿科学目标，将分阶段推出多个面向公众的协同标注项目，涵盖但不限于：超弥散星系（Ultra-Diffuse Galaxies）识别、星系并合系统（Merger Galaxies）识别、环状星系（Ring Galaxies）识别等关键课题。',
      
      text1: '本项目所用数据源自国际前沿的暗能量光谱巡天项目（DESI），该项目由美国能源部主导，旨在通过大规模星系红移测量精确刻画宇宙膨胀历史及暗能量性质。我们采用其第九版成像数据发布（DESI Imaging Data Release 9, DR9）。该数据集整合了BASS（北天）、MzLS（中天）与DECaLS（南天）三大深度光学巡天的协同观测成果，覆盖约14,000平方度天区，提供g、r、z三波段高信噪比、均匀校准的成像数据，极限面亮度可达约28 mag/arcsec²。在此基础上，我们融合了由领域专家基于形态学特征构建的异常天体候选体目录。该目录通过人工目视标注样本与基于样本自动化初筛相结合的方式生成。结合DESI DR9的深度、广度与图像质量，本季任务为公众科学参与者提供了当前最先进、最适宜开展异常星系发现与验证的观测平台。',

      text2: '无论您是否具备天文学专业背景，只要怀有对宇宙奥秘的好奇心，并拥有一台可联网的计算机，即可加入这一全球性的科学协作网络。通过与科研人员紧密配合，您将直接参与对各类异常天体结构的识别、分类与标注，为揭示星系形成与演化机制提供宝贵数据支持。让我们携手，在浩瀚星海中点亮未知——您的每一次点击，都可能成为推动天文学进步的关键一步。', src: require('@/assets/angalaxyexamle.png')
    },
    dataintroduce: {
      name: '超弥散星系项目', text: '超弥散星系（Ultra-Diffuse Galaxies, UDGs）是一类极端特殊的低表面亮度星系。它们拥有与银河系相当的物理尺寸（有效半径 > 1.5 kpc），但恒星数量却不足银河系的1%，导致其表面亮度极低，远暗于夜天光背景，如同宇宙中的“幽灵”。UDGs的发现对标准宇宙学模型（ΛCDM）提出了严峻挑战。部分UDGs被观测到拥有异常巨大的暗物质晕，其质量-光度比远超普通星系。它们究竟是早期宇宙中“失败”的星系，还是在星系团环境中被剧烈剥离后的残骸？解答这些问题，将深刻影响我们对星系形成、暗物质本质及宇宙结构演化的理解。',


      text1: '积分说明：每个项目开始时积分清零。有效标注一个异常天体可获得基础积分；高准确率、连续登录及高产用户将享受额外积分加成。积分可累积，达到指定阈值后可兑换荣誉称号与实物奖品。',

      text2: '注意事项：',

      text3: '1. 标注准确率下降将导致扣分！请务必保证标注质量！',

      text4: '2. 每个项目的开始将根据您的上项目的表现进行初始积分奖励！', src: require('@/assets/udg.png'),
    },
  },
]

// 数组索引
export const index = 0;

